import React, { useContext } from 'react';
import { useMedia } from 'react-use';
import { Icon } from 'ck-ui';
import { ProductListingPageContext } from '../context';
import styles from './ResponsiveColumn.module.scss';

export const ResponsiveColumn = () => {
  const { columns, setColumns } = useContext(ProductListingPageContext);
  const isSmall = useMedia('(max-width: 359px)');

  if (isSmall) return null;

  return (
    <span className={styles.root}>
      <Icon
        name="column-double"
        color={columns === 2 ? null : 'grey-dark'}
        onClick={() => setColumns(2)}
      />
      <Icon
        name="column-single"
        color={columns === 1 ? null : 'grey-dark'}
        onClick={() => setColumns(1)}
      />
    </span>
  );
};
